import { Organisation } from '../models/Organisations.model';

export const displayOrg = (org: Organisation): string => org ? `${org.name} - ${org.erpId}` : '';

export const normalizePath = (path: string): string => path.replace(/^\/+|\/+$/g, '');

export const arraysAsSetsEqual = <T>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) {
    return false;
  }

  const setA = new Set(a);
  const setB = new Set(b);

  if (setA.size !== setB.size) {
    return false;
  }

  return [...setA].every(item => setB.has(item));
}
